<template>
  <div>
    <h1 class="fz-32">Orders</h1>
    <div class="d-flex align-center flex-wrap gap-10 mb-4">
      <v-text-field
        v-model="filters.search"
        placeholder="Search"
        autocomplete="off"
        prepend-inner-icon="mdi-magnify"
        background-color="white"
        hide-details
        outlined
        dense
        @change="getOrders"
      />
      <v-btn-toggle class="rounded-lg flex-wrap" style="border: solid 1px rgba(0, 0, 0, 0.3);" dense>
        <v-btn :height="40" color="white" class="px-3">
          <Icon icon="mingcute:filter-3-line" :width="18" :height="18" class="mr-1" /> Filter by
        </v-btn>
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="white" :height="40" class="px-3" v-bind="attrs" v-on="on"
              >Date <Icon icon="uil:angle-down" :width="22" :height="22" class="ml-1"
            /></v-btn>
          </template>
          <v-card class="pa-0 h-full">
            <v-date-picker v-model="filters.dateRanges" no-title range></v-date-picker>
            <v-divider></v-divider>
            <div class="pa-4">
              <p class="fz-14">*You can choose multiple Fulfillment type</p>
              <v-btn color="primary" block @click="getOrders" :disabled="filters.dateRanges.length < 2" depressed
                >Apply Now</v-btn
              >
            </div>
          </v-card>
        </v-menu>
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="white" :height="40" class="px-3" v-bind="attrs" v-on="on"
              >Fulfillment Status <Icon icon="uil:angle-down" :width="22" :height="22" class="ml-1"
            /></v-btn>
          </template>
          <v-card class="pa-4">
            <h3>Select Fulfillment Type</h3>
            <v-chip-group v-model="filters.fulfillmentStatus" column multiple class="mb-2" color="primary">
              <v-chip filter outlined v-for="item in fulfillmentStatusList" :key="item.value" :value="item.value" dense>
                {{ item.text }}
              </v-chip>
            </v-chip-group>
            <v-divider class="mb-3"></v-divider>
            <p class="fz-14">*You can choose multiple Fulfillment type</p>
            <v-btn color="primary" class="px-10" @click="getOrders" depressed>Apply Now</v-btn>
          </v-card>
        </v-menu>
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="white" :height="40" class="px-3" v-bind="attrs" v-on="on"
              >Order Status <Icon icon="uil:angle-down" :width="22" :height="22" class="ml-1"
            /></v-btn>
          </template>
          <v-card class="pa-4">
            <h3>Select Status Type</h3>
            <v-chip-group v-model="filters.financialStatus" column multiple class="mb-2" color="primary">
              <v-chip filter outlined v-for="item in financialStatusList" :key="item.value" :value="item.value" dense>
                {{ item.text }}
              </v-chip>
            </v-chip-group>
            <v-divider class="mb-3"></v-divider>
            <p class="fz-14">*You can choose multiple Status type</p>
            <v-btn color="primary" class="px-10" @click="getOrders" depressed>Apply Now</v-btn>
          </v-card>
        </v-menu>
        <v-btn color="error" text :height="40" class="px-3" @click="onResetFilters">
          <Icon icon="tabler:restore" :width="18" :height="18" class="mr-1" />
          Reset Filter
        </v-btn>
      </v-btn-toggle>
      <v-btn
        v-if="utilities.checkPermisson(`export_orders`, user)"
        color="primary"
        :height="40"
        class="px-5"
        @click="showExportModal = true"
        depressed
      >
        Export
      </v-btn>
    </div>
    <!-- <v-btn color="primary" @click.stop="drawer = !drawer">More filters </v-btn> -->
    <!-- <v-btn outlined class="ml-2" color="primary"
        ><i class="fas fa-download"></i>{{ $t('Import tracking number') }}
      </v-btn> -->
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="orders"
      :items-per-page="filters.limit"
      :page.sync="filters.page"
      item-key="_id"
      :hide-default-footer="true"
      style="border: solid 1px rgba(0, 0, 0, 0.3)"
    >
      <template v-slot:[`item.orderId`]="{ item }">
        <router-link
          class="router-link font-weight-bold"
          target="_blank"
          :to="{ name: 'website.orders.detail', params: { id: item.id } }"
        >
          {{ item.orderName }}
        </router-link>
      </template>
      <template v-slot:[`item.capturedDate`]="{ item }">
        {{ formatDate(item.capturedDate) }}
      </template>
      <template v-slot:[`item.customerInfo`]="{ item }">
        {{ item.customerInfo[0].full_name }}
      </template>
      <template v-slot:[`item.financialStatus`]="{ item }">
        <span class="text-capitalize">{{ item.financialStatus }}</span>
      </template>
      <template v-slot:[`item.paymentName`]="{ item }">
        <span class="text-capitalize">{{ item.paymentName }}</span>
      </template>
      <template v-slot:[`item.fulfillmentStatus`]="{ item }">
        <span class="text-capitalize">{{ item.fulfillmentStatus }}</span>
      </template>
      <template v-slot:[`item.fulfillmentStatus`]="{ item }">
        <span class="text-capitalize">{{ item.fulfillmentStatus }}</span>
      </template>
      <template v-slot:[`item.total`]="{ item }">
        <span class="font-weight-medium error--text">{{ formatMoney(item.paidInfo.sub_total) }}</span>
      </template>
    </v-data-table>
    <div class="d-flex align-center flex-wrap mt-4 gap-12">
      <div class="w-150 mr-auto">
        <v-select
          :items="[20, 40, 60]"
          hide-details="auto"
          v-model="filters.limit"
          suffix="/ Page"
          dense
          outlined
          background-color="white"
          @change="getOrders"
        ></v-select>
      </div>
      <v-pagination
        v-model="filters.page"
        :length="totalPages"
        :total-visible="15"
        :visible="7"
        @input="getOrders"
      ></v-pagination>
    </div>
    <v-dialog v-model="showExportModal" :width="500">
      <v-card class="pa-4">
        <h2 class="primary--text mb-3">Export orders</h2>
        <label class="label-form">Store</label>
        <v-select
          v-model="filters.stores"
          :items="stores"
          multiple
          chips
          item-value="id"
          item-text="storeDetail.defaultSystemDomain"
          clearable
          outlined
          dense
        ></v-select>
        <label class="label-form">Export</label>
        <v-radio-group v-model="exportType" class="mt-1" dense>
          <v-radio value="all-products" label="All orders"></v-radio>
          <v-radio value="curent-search" label="Current search"></v-radio>
        </v-radio-group>
        <div class="d-flex justify-end">
          <v-btn :loading="isExporting" color="primary" @click="onExportCSV" depressed>Export</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import utilities from '@/helpers/utilities';
import { storeService } from '@/apis/store.s';
import { orderApi } from '@/apis/order';
import { Icon } from '@iconify/vue2';
import moment from 'moment';
export default {
  components: { Icon },
  data() {
    return {
      stores: [],
      utilities,
      exportType: 'all-products',
      showExportModal: false,
      headers: [
        {
          text: 'ID',
          value: 'orderId',
          sortable: false,
        },
        {
          text: 'Capture date',
          value: 'capturedDate',
          sortable: false,
        },
        {
          text: 'Customer',
          value: 'customerInfo',
          sortable: false,
        },
        {
          text: 'Payment status',
          value: 'financialStatus',
          sortable: false,
        },
        {
          text: 'Payment methods',
          value: 'paymentName',
          sortable: false,
        },
        {
          text: 'Fulfillment status',
          value: 'fulfillmentStatus',
          sortable: false,
        },
        {
          text: 'Total',
          value: 'total',
          align: 'right',
          sortable: false,
        },
      ],
      orders: [],
      loading: false,
      filters: {
        search: '',
        page: 1,
        limit: 20,
        financialStatus: [],
        fulfillmentStatus: [],
        dateRanges: [],
        stores: [],
      },
      totalPages: 1,
      financialStatusList: [
        {
          text: 'Paid',
          value: 'paid',
        },
        {
          text: 'Canceled',
          value: 'canceled',
        },
        {
          text: 'Refunded',
          value: 'refunded',
        },
        {
          text: 'Partially Refunded',
          value: 'partially_refunded',
        },
        {
          text: 'Disputed',
          value: 'disputed',
        },
      ],
      fulfillmentStatusList: [
        {
          text: 'Unfulfilled',
          value: 'unfulfilled',
        },
        {
          text: 'Partially unfulfilled',
          value: 'partially_unfulfilled',
        },
        {
          text: 'Fulfilled',
          value: 'fulfilled',
        },
        {
          text: 'Processing',
          value: 'processing',
        },
        {
          text: 'Partially processing',
          value: 'partially_processing',
        },
      ],
      isExporting: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
    timezone() {
      return this.$store.getters.pagePreference?.standardTimezone || 'America/Los_Angeles';
    },
  },

  methods: {
    async getStores() {
      try {
        const { data } = await storeService.list({
          limit: 100,
        });
        this.stores =
          data
            ?.filter(item => item !== null)
            ?.map(store => ({
              ...store,
              storeName: store.storeDetail.name,
            })) || [];
      } catch (error) {
        console.log('🚀 ~ getStores ~ error:', error);
      }
    },
    downloadFile(fileName, urlData) {
      var aLink = document.createElement('a');
      aLink.download = fileName;
      aLink.href = urlData;
      var event = new MouseEvent('click');
      aLink.dispatchEvent(event);
    },
    async onExportCSV() {
      try {
        this.isExporting = true;
        let params = {
          page: this.filters.page,
          limit: this.filters.limit,
          search: this.filters.search,
          financialStatus: this.filters.financialStatus.join(','),
          fulfillmentStatus: this.filters.fulfillmentStatus.join(','),
          orderDate: {
            startDate: null,
            endDate: null,
            timezone: this.timezone,
          },
          storeIds: this.filters.stores.join(','),
        };
        if (!params.search) delete params.search;
        if (!params.financialStatus) delete params.financialStatus;
        if (!params.fulfillmentStatus) delete params.fulfillmentStatus;
        if (!params.storeIds) delete params.storeIds;
        if (this.filters.dateRanges.length < 2) delete params.orderDate;
        else {
          params.orderDate.startDate = moment(this.filters.dateRanges[0]).format('YYYY-MM-DD');
          params.orderDate.endDate = moment(this.filters.dateRanges[1]).format('YYYY-MM-DD');
        }
        if (this.exportType === 'all-products') {
          params = {
            storeIds: this.filters.stores.join(','),
          };
        }
        const { data } = await orderApi.getExport(params);
        this.downloadFile('export.csv', 'data:text/csv;charset=UTF-8,' + encodeURIComponent(data));
        this.showExportModal = false;
      } catch (error) {
        console.log('🚀 ~ onExportCSV ~ error:', error);
      } finally {
        this.isExporting = false;
      }
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY  HH:mm:ss');
    },
    async getOrders() {
      try {
        this.loading = true;
        const params = {
          page: this.filters.page,
          limit: this.filters.limit,
          search: this.filters.search,
          financialStatus: this.filters.financialStatus.join(','),
          fulfillmentStatus: this.filters.fulfillmentStatus.join(','),
          orderDate: {
            startDate: null,
            endDate: null,
            timezone: this.timezone,
          },
        };
        if (!params.search) delete params.search;
        if (!params.financialStatus) delete params.financialStatus;
        if (!params.fulfillmentStatus) delete params.fulfillmentStatus;
        if (this.filters.dateRanges.length < 2) delete params.orderDate;
        else {
          params.orderDate.startDate = moment(this.filters.dateRanges[0]).format('YYYY-MM-DD');
          params.orderDate.endDate = moment(this.filters.dateRanges[1]).format('YYYY-MM-DD');
        }
        const { data } = await orderApi.get(params);
        this.orders = data;
        const count = await orderApi.getCount(params);
        this.totalPages = Math.ceil(count.data / params.limit);
      } catch (error) {
        console.log('🚀 ~ getOrders ~ error:', error);
      } finally {
        this.loading = false;
      }
    },
    formatMoney(money) {
      if (!money) return '$0';
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter.format(money);
    },
    onResetFilters() {
      this.filters.search = '';
      this.filters.financialStatus = [];
      this.filters.fulfillmentStatus = [];
      this.filters.dateRanges = [];
      this.getOrders();
    },
  },
  created() {
    this.getStores();
    this.getOrders();
  },
};
</script>
